import React, { FC, useRef } from "react";
import classNames from "classnames";
import { SearchIcon } from "@/icons/primary";
import { Spiner } from "src/common";

export type ChatInputSearchProps = {
  styleWrapper?: React.CSSProperties;
  placeholder?: string;
  onClick?: (value: string) => void;
  onChange?: (value: string) => void;
  disabled?: boolean;
  loading?: boolean;
};

export const ChatInputSearch: FC<ChatInputSearchProps> = ({
  placeholder,
  onClick,
  onChange,
  disabled,
  loading,
}) => {
  const [insideValue, setInsideValue] = React.useState<string>("");

  const rootEl = useRef<HTMLDivElement>(null);

  return (
    <div ref={rootEl} className='relative'>
      <input
        className={classNames([
          "bg-white py-2.5 pl-2.5 pr-10 w-full text-sm border rounded-sm border-light-neutral-2",
        ])}
        value={insideValue}
        placeholder={placeholder}
        onChange={(e) => {
          setInsideValue(e.target.value);
          onChange && onChange(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !disabled) {
            setInsideValue("");
            onClick && onClick(insideValue);
          }
        }}
      />

      {loading && (
        <div className='absolute top-0 bottom-0 right-12 flex items-center'>
          <Spiner width='15' />
        </div>
      )}

      <div
        className='absolute right-5'
        onClick={() => {
          if (!disabled) {
            setInsideValue("");
            onClick && onClick(insideValue);
          }
        }}
        style={{
          margin: "auto",
          cursor: disabled ? "not-allowed" : "pointer",
          filter: `grayscale(${disabled ? "100%" : "0"})`,
          opacity: disabled ? 0.5 : 1,
          height: "24px",
          top: "5px",
        }}
      >
        <SearchIcon />
      </div>
    </div>
  );
};
